module.exports = __webpack_public_path__ + "media/images/emblems/Payerne-coat_of_arms-55f36281e59d958f23022970e3695409.svg";